module.exports = __webpack_public_path__ + "img/20180815_145911_038.8247e577.jpg";